import CustomCheckbox, { CustomCheckboxProps } from "../CustomCheckbox";
import { featuresAndReqs } from "../../utils/constants";
import { useNavigate, useSearchParams } from "react-router-dom";

const AccountFeatures: React.FC<Partial<CustomCheckboxProps>> = ({
  checked,
  onClickCheck,
}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedType = searchParams.get("type");
  const isInView = searchParams.get("view") === "features";

  const handleClickViewTAndC = () => {
    searchParams.set("view", "terms-and-conditions");
    setSearchParams(searchParams);
  };

  const removeSearchParams = (param: string) => {
    searchParams.delete(param);
    setSearchParams(searchParams);
  };

  const handleClickGetStarted = () => {
    if (!checked) return;
    removeSearchParams("view");
    navigate(`/upgrade-account?type=${selectedType}`);
  };

  const handleClickCancel = () => {
    removeSearchParams("view");
  };

  return (
    <>
      {isInView && (
        <div className="d-grid gap-3">
          <div className="row">
            <div className="col-12 col-lg-6">
              <p className="mb-2">Features</p>
              <ul className="d-flex flex-column align-items-start gap-3 list-unstyled">
                {featuresAndReqs[selectedType].features.map(
                  (feature: string) => (
                    <li
                      className="d-flex align-items-start justify-content-start gap-2"
                      key={feature}
                    >
                      <div
                        className="shadow-sm rounded-circle"
                        style={{
                          width: "7px",
                          height: "7px",
                          backgroundColor: "#66CC15",
                        }}
                      ></div>
                      <span
                        className="my-0 py-0 lh-1 d-inline-block fw-normal fs-6 text-secondary"
                        style={{ maxWidth: "90%" }}
                      >
                        {feature}
                      </span>
                    </li>
                  ),
                )}
              </ul>
            </div>
            <div className="col-12 col-lg-6">
              <p className="mb-2">Requirements</p>
              <ul className="d-flex flex-column align-items-start gap-3 list-unstyled">
                {featuresAndReqs[selectedType].requirements.map(
                  (req: string) => (
                    <li
                      className="d-flex align-items-start justify-content-start gap-2"
                      key={req}
                    >
                      <div
                        className="shadow-sm rounded-circle"
                        style={{
                          width: "7px",
                          height: "7px",
                          backgroundColor: "#66CC15",
                        }}
                      ></div>
                      <span
                        className="my-0 py-0 lh-1 d-inline-block fw-normal fs-6 text-secondary"
                        style={{ maxWidth: "90%" }}
                      >
                        {req}
                      </span>
                    </li>
                  ),
                )}
              </ul>
            </div>
          </div>
          <CustomCheckbox
            checked={checked}
            onClickCheck={onClickCheck}
            message={
              <span>
                By checking this box, you have accepted the{" "}
                <u
                  className="text-danger"
                  onClick={handleClickViewTAndC}
                  role="button"
                >
                  Terms and conditions
                </u>
              </span>
            }
          />
          <div className="w-100 d-flex gap-2 align-items-center justify-content-between">
            <button onClick={handleClickCancel}>Cancel</button>
            <button
              disabled={!checked}
              className={`coloredBtn ${checked ? "" : "disabled"}`}
              onClick={handleClickGetStarted}
            >
              Get started
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountFeatures;
